import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { Tabs } from 'antd';
import PayableStore from '../stores/PayableStore';
import PayableControlStore from '../stores/PayableControlStore';

import PayableGrid from './PayableGrid';
import PayableControlGrid from './PayableControlGrid';
import RegenerateIc from './RegenerateIc';
import { pageSectionTitle } from '../util/Style';

const { TabPane } = Tabs;

const tabBarStyle = {
    fontWeight: "bold",
}

class PayableUI extends Component {

    constructor(props) {
        super(props);

        this.dailyStore = new PayableStore({ apiProxy: props.appStore.apiProxy, collectionType: "daily" });
        this.monthlyStore = new PayableStore({ apiProxy: props.appStore.apiProxy, collectionType: "monthly" });
        this.controlStore = new PayableControlStore({ apiProxy: props.appStore.apiProxy, collectionType: "unknown", stores: [this.dailyStore, this.monthlyStore] });
        this.icStore = new PayableControlStore({ apiProxy: props.appStore.apiProxy, collectionType: "unknown"});

    }

    render() {
        return (
            <Tabs style={{paddingLeft:10,paddingRight:10}} defaultActiveKey="1" tabBarStyle={tabBarStyle} tabBarExtraContent={pageSectionTitle("Payables")}>
                <TabPane tab="Unmatched" key="1">
                    <PayableControlGrid appStore={this.props.appStore} title="Error" store={this.controlStore} />
                </TabPane>
                <TabPane tab="Daily" key="2">
                    <PayableGrid appStore={this.props.appStore} title="Daily" store={this.dailyStore} />
                </TabPane>
                <TabPane tab="Monthly" key="3">
                    <PayableGrid appStore={this.props.appStore} title="Monthly" store={this.monthlyStore} />
                </TabPane>

                <TabPane tab="Regenerate IC" key="4">
                    <RegenerateIc appStore={this.props.appStore} title="Regenerate IC" store={this.icStore}/>
                </TabPane>
                
            </Tabs>
        )
    }
}

export default observer(PayableUI)
